import { ProtoDate } from '../../api/types';

/** Convert "YYYY-MM-DD" to ProtoDate {year, month, day}. */
export const isoToProtoDate = (iso: string): ProtoDate => {
  const [y, m, d] = iso.split('-').map(s => parseInt(s, 10));
  return { year: y, month: m, day: d };
};

export const protoDateToIso = (p: ProtoDate): string => {
  const m = String(p.month).padStart(2, '0');
  const d = String(p.day).padStart(2, '0');
  return `${p.year}-${m}-${d}`;
};

/** Midpoint date string for two ISO dates (used by Step 11 service-date validation). */
export const midpointIso = (start: string, end: string): string => {
  const s = new Date(start).getTime();
  const e = new Date(end).getTime();
  if (Number.isNaN(s) || Number.isNaN(e)) return start;
  const mid = new Date((s + e) / 2);
  const y = mid.getFullYear();
  const m = String(mid.getMonth() + 1).padStart(2, '0');
  const d = String(mid.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};
